
export default function About() {
  return (
    <section id="about" className="py-32 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-light mb-8 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            About the Festival
          </h2>
        </div>

        <div className="space-y-8 text-lg text-gray-700 leading-relaxed">
          <p>
            Caribbean Fashion Fest is a new international platform connecting Caribbean designers with the global fashion industry. We are not a festival. We are a fashion week.
          </p>
          
          <p>
            Our mission is to elevate Caribbean design beyond regional boundaries, creating opportunities for emerging and established designers to showcase their work on a global stage.
          </p>

          <p>
            The Caribbean has always been a place of innovation, craftsmanship, and cultural synthesis. Our designers bring unique perspectives shaped by island life, ocean rhythms, and centuries of creative tradition.
          </p>

          <p>
            Caribbean Fashion Fest provides the infrastructure, audience, and credibility these designers deserve. We curate carefully. We produce professionally. We think globally.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pt-16">
            <div className="text-center">
              <div className="text-5xl font-light text-[#14B8A6] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                25+
              </div>
              <p className="text-sm tracking-wide text-gray-600">FEATURED DESIGNERS</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-light text-[#14B8A6] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                12
              </div>
              <p className="text-sm tracking-wide text-gray-600">RUNWAY SHOWS</p>
            </div>
            <div className="text-center">
              <div className="text-5xl font-light text-[#14B8A6] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                3
              </div>
              <p className="text-sm tracking-wide text-gray-600">DAYS OF FASHION</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
